import React from "react"
import { StaticImage } from "gatsby-plugin-image"

function Quote({ attribution, quote, index }) {
  return (
    <li className="relative">
      <figure className="px-6 py-10 space-y-6 bg-white lg:px-16 lg:py-12">
        {attribution && (
          <blockquote className="lead-copy text-darkNavy">
            “{quote?.internal?.content}”
          </blockquote>
        )}
        {quote && (
          <figcaption className="lead-bold text-darkNavy">
            {attribution}
          </figcaption>
        )}
      </figure>
      {index === 1 && (
        <div>
          <div className="absolute top-0 bottom-0 hidden -left-18 md:block">
            <div
              className="absolute bottom-0 h-px bg-mineralGray"
              style={{
                left:
                  "calc( ( ( ((90rem - (6.5rem * 2)) - (2rem * 11)) / 12 ) * -1 ) - (2rem + 6.5rem) )",
                width: 600,
              }}
            />
            <div
              className="absolute right-0 w-px top-20 bg-mineralGray"
              style={{ height: 440 }}
            />
          </div>
          <div className="quote-list__texture-2">
            <div className="aspect-w-3 aspect-h-10 ring-1 ring-mineralGray">
              <StaticImage
                src="../../../assets/product-categories/honey.jpg"
                placeholder="blurred"
                width={208}
                alt="Honey very close"
                objectFit="cover"
                objectPosition="center"
                backgroundColor="#c48f46"
                style={{ position: "absolute" }}
              />
            </div>
          </div>
        </div>
      )}
    </li>
  )
}

export default Quote
